export const HOST = 'https://admin.iuxmarket.com';
// export const HOST = 'https://dev.iuxmarket.com'
export const CLIENT_ID = 1;
export const CLIENT_SECRET = '$2y$12$pRtLLfAWY0KtGJDZr88cE.xraqEq2.2CGNmKe6u1tUfhR8/h5wX1u'
export const LANG = 'th'